// Single source of truth for the front version, shared by main and renderer.
// Vite inlines the named JSON import at build time (only `version` is kept), so it's
// synchronous everywhere: no IPC round-trip and no store needed to read it.
import { version } from '../../package.json'

export const APP_VERSION: string = version
